import React, { useEffect } from "react";
import AllRoute from "../router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSplitTextAnimation from "../../components/splittextAnimation/useSplitTextAnimation";
import Lenis from "lenis";
import ErrorBoundary from "./ErrorBoundary";

const App: React.FC = () => {
  useSplitTextAnimation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
    });

    const raf = (time: number) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    // ✅ Cleanup to prevent memory leaks
    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App lenis" id="scrool">
      <ErrorBoundary>
        <AllRoute />
      </ErrorBoundary>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default App;
